import { KeyValuePipe } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { DeviceTypeParameterConfigWithAvailableListAndParameter } from '@vectronic/util';

@Component({
  selector: 'vectronic-parameter-selection-config',
  templateUrl: './parameter-selection-config.component.html',
  styleUrls: ['./parameter-selection-config.component.scss'],
  imports: [
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatSuffix,
    MatIcon,
    MatTooltip,
    KeyValuePipe,
    MatIconButton,
  ],
})
export class ParameterSelectionConfigComponent {
  config = input<DeviceTypeParameterConfigWithAvailableListAndParameter>();
  value = input<string>();
  disabled = input(false);
  readonly = input<boolean>();
  resetToFactoryTooltip = input<string>();

  hideLabel = input<boolean>();
  hasClose = input(false);
  showInfo = input(true);
  hasDelete = input(true);
  hasUndo = input(false);
  showReset = input<boolean>();

  configClose = output();
  parameterChange = output<{
    config: DeviceTypeParameterConfigWithAvailableListAndParameter;
    value: string;
  }>();
  parameterUndo = output<DeviceTypeParameterConfigWithAvailableListAndParameter>();
  resetToFactory = output<DeviceTypeParameterConfigWithAvailableListAndParameter>();

  onSelectionChange(
    $event: MatSelectChange,
    config: DeviceTypeParameterConfigWithAvailableListAndParameter,
  ) {
    this.parameterChange.emit({ config, value: $event.value });
  }

  get validEnumCoding() {
    const vvr = this.config().validValueRange ?? this.config().parameter.validValueRange;
    const validEnumCoding = { ...this.config().parameter.enumCoding };

    this.removeKeysOutsideList(validEnumCoding, vvr);
    this.removeKeysAboveMax(validEnumCoding, vvr);
    this.removeKeysBelowMin(validEnumCoding, vvr);

    return validEnumCoding;
  }

  private removeKeysOutsideList(
    validEnumCoding: { [key: string]: string },
    vvr: DeviceTypeParameterConfigWithAvailableListAndParameter['validValueRange'],
  ) {
    if (!vvr.list) return;
    for (const key in validEnumCoding) {
      if (!vvr.list.includes(+key)) delete validEnumCoding[key];
    }
  }

  private removeKeysAboveMax(
    validEnumCoding: { [key: string]: string },
    vvr: DeviceTypeParameterConfigWithAvailableListAndParameter['validValueRange'],
  ) {
    if (vvr.max == null) return;
    for (const key in validEnumCoding) {
      if (+key > vvr.max) delete validEnumCoding[key];
    }
  }

  private removeKeysBelowMin(
    validEnumCoding: { [key: string]: string },
    vvr: DeviceTypeParameterConfigWithAvailableListAndParameter['validValueRange'],
  ) {
    if (vvr.min == null) return;
    for (const key in validEnumCoding) {
      if (+key < vvr.min) delete validEnumCoding[key];
    }
  }

  onClickRemove() {
    this.parameterChange.emit({ config: this.config(), value: undefined });
  }

  get parameterTitle() {
    const { name, subcategory } = this.config().parameter;
    if (subcategory) return `${subcategory} / ${name}`;
    else return name;
  }

  onClickClose() {
    this.configClose.emit();
  }

  onClickUndo() {
    this.parameterUndo.emit(this.config());
  }

  onResetToFactory() {
    this.resetToFactory.emit(this.config());
  }
}
